import _ from 'lodash';
import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import ApiService from '@/services/common/api.service';
import StorageService from "@/services/common/storage.service";

const VoucherService = {
    getVoucherByCash,
    getVoucherDetails,
    getVoucherByGroupTypes,
    addVoucher,
    addVoucherContract,
    updateContract,
    deleteVoucher,
    forceDeleteContract,
    list,
    getNonTravelList,
    details,
    remove,
    upload,
    updateFile,
    checkPwdPdf,
    getPdf,
    contracts,
    subContracts,
};

async function list (cahsId = "", currencyId = "", screenType = "", groupType = "") {
    try {
        let url = `${process.env.API_URL}/vouchers`;
        if (cahsId) {
            url += `?cashId=` + cahsId;
        }
        if (currencyId && screenType == Constants.CashScreenType) {
            url += `&currencyId=` + currencyId;
        }
        if (screenType) {
            url += `&cashInOutType=` + screenType;
            if (screenType == Constants.ExchangeScreenType) {
                url += `&voucherType=` + Constants.VoucherType.currency_exchange_receipt_cash.id;
            }
        }
        if (groupType) {
            if (groupType == Constants.GroupVoucherType.cash_detail.id) {
                url += `&`;
            } else {
                url += `?`;
            }
            url += `groupType=` + groupType;
        }
        let user = JSON.parse(StorageService.getUser());
        let groups = user.groups[0];
        url += `&groupId=` + groups.id;
        let tour = JSON.parse(StorageService.getTour());
        if (tour && !Utils.isEmptyStr(tour.tour_number)) {
            // ツアーあり
            url += `&tourNumber=` + tour.tour_number;
        } else {
            // ツアーなし
            url += `&tourNumber`;
        }
        let requestData = {
            method: 'get',
            url: url,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function getNonTravelList (voucherTypeId) {
    try {
        // 旅行勘定・未渡団体以外の証票種別か確認
        if (!Utils.isVoucherTypeNonTravel(voucherTypeId)) {
            return {status: 200, data: {}};
        }
        const user = JSON.parse(StorageService.getUser());
        const groupId = user.groups[0].id;
        const requestData = {
            method: 'get',
            url: `${process.env.API_URL}/vouchers?groupId=${groupId}&voucherTypeId=${voucherTypeId}`,
        };
        return await ApiService.customRequest(requestData);
    } catch (error) {
        return error;
    }
}

async function contracts (screenType) {
    try {
        const user = JSON.parse(StorageService.getUser());
        const groups = user.groups[0];
        const tour = JSON.parse(StorageService.getTour());
        let tourNumber = "";
        if (tour) {
            tourNumber = tour.tour_number;
        } else {
            // 別ユーザの情報も表示してしまうため、暫定対応で、ツアーの指定がない場合は一覧表示しない
            return {status: 200, data:{}};
        }
        let url = `/vouchers/contracts?tourNumber=${tourNumber}&screenType=${screenType}`;
        if (!Utils.isEmptyStr(groups.id)) {
            url += `&groupId=${groups.id}`;
        }
        return await ApiService.get(url);
    } catch (err) {
        return err;
    }
}

async function subContracts (voucherType) {
    try {
        const user = JSON.parse(StorageService.getUser());
        const groups = user.groups[0];
        const tour = JSON.parse(StorageService.getTour());
        let tourNumber = "";
        if (tour) {
            tourNumber = tour.tour_number;
        } else {
            // 別ユーザの情報も表示してしまうため、暫定対応で、ツアーの指定がない場合は一覧表示しない
            return {status: 200, data:{}};
        }
        let url = `/vouchers/subContracts?tourNumber=${tourNumber}&voucherType=${voucherType}`;
        if (!Utils.isEmptyStr(groups.id)) {
            url += `&groupId=${groups.id}`;
        }
        return await ApiService.get(url);
    } catch (err) {
        return err;
    }
}

async function details (id) {
    let url = '/vouchers/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function remove (id) {
    try {
        let requestData = {
            method: 'delete',
            url: `${process.env.API_URL}/vouchers/` + id,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherByCash (cashId = "", currencyId = "") {
    let url = '/vouchers?cashId=' + cashId + '&currencyId=' + currencyId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherDetails (voucherId = "") {
    let url = '/vouchers/' + voucherId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getVoucherByGroupTypes (groupType = "") {
    let url = '/vouchers?groupType=' + groupType;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function addVoucher (id, params) {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        // params._token = Utils.generateRandomString();
        // BOXフォルダIDの取得
        params.boxFolderId = getBoxFolderId(params);

        if (!Utils.isEmptyStr(id)) {
            let url = '/vouchers/' + id;
            response = await ApiService.put(url, params);
        } else {
            let user = StorageService.getUser();
            let groups;
            if (user) {
                user = JSON.parse(user);
                if (user.groups[0]) {
                    groups = user.groups[0];
                }
                params.groupId = groups.id;
            } else {
                params.groupId = "";
            }
            let url = '/vouchers';
            let requestData = {
                method: 'post',
                data: params,
                url: url,
                isUpload: !Utils.isEmptyStr(params.filePath),
            }
            response = await ApiService.customRequest(requestData);
        }

        return response;
    } catch (error) {
        return error;
    }
}

function getBoxFolderId (params) {
    // ツアー無しor帳票無しの場合はブランク
    const voucherTypeId = params.voucherTypeId;
    if (Utils.isEmptyStr(params.tourNumber) || voucherTypeId == Constants.VoucherType.no_voucher.id || voucherTypeId == Constants.VoucherType.local_placement_income_other_no_voucher.id) {
        return "";
    };

    // 携行現金収支明細タブ…持出金申請のフォルダ情報取得
    const groupType = JSON.parse(StorageService.getGroupVoucherType());
    console.log(`groupType....${JSON.stringify(groupType)}`)
    if (groupType.id === Constants.GroupVoucherType.cash_detail.id) {
        const cashBoxFolderId = JSON.parse(StorageService.getCashBoxFolderId());
        return cashBoxFolderId.boxFolderId;
    };

    // 証票明細登録タブ…ツアー情報取得SOQLの結果からフォルダ情報取得
    const boxFolderIdMap = JSON.parse(StorageService.getBoxFolderIdMap());
    console.log(`boxFolderIdMap....${JSON.stringify(boxFolderIdMap)}`)
    let dmosKey = "";
    for (const voucherBoxFolderName of Constants.VoucherBoxFolderNames) {
        if (voucherTypeId == voucherBoxFolderName.voucherTypeId) {
            dmosKey = voucherBoxFolderName.dmosKey;
            break;
        };
    };

    return boxFolderIdMap[dmosKey];
}

async function addVoucherContract (params, id = "") {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        // params._token = Utils.generateRandomString();
        if (!Utils.isEmptyStr(id)) {
            let url = '/vouchers/check-in/' + id;
            response = await ApiService.put(url, params);
        } else {
            let user = StorageService.getUser();
            let groups;
            if (user) {
                user = JSON.parse(user);
                if (user.groups[0]) {
                    groups = user.groups[0];
                }
                params.groupId = groups.id;
            } else {
                params.groupId = "";
            }
            let url = '/vouchers/contracts';
            response = await ApiService.post(url, params);
        }

        return response;
    } catch (error) {
        return error;
    }
}

async function updateContract (params) {
    try {
        let response = null;

        if (!Utils.isEmptyStr(params.transactionDate)) {
            params.transactionDate = DateUtils.formatDateDefault(params.transactionDate);
        }

        let user = StorageService.getUser();
        let groups;
        if (user) {
            user = JSON.parse(user);
            if (user.groups[0]) {
                groups = user.groups[0];
            }
            params.groupId = groups.id;
        } else {
            params.groupId = "";
        }

        let url = '/vouchers/update-contract/' + params.id;
        response = await ApiService.put(url, params);

        return response;
    } catch (error) {
        return error;
    }
}

async function deleteVoucher (voucherId = "") {
    let url = '/vouchers/' + voucherId;
    try {
        let response = await ApiService.delete(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function forceDeleteContract (contractId = "") {
    const url = `/vouchers/contracts/${contractId}`;
    try {
        const response = await ApiService.delete(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function upload (formData) {
    try {
        let requestData = {
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${process.env.API_URL}/uploadfile/`,
            isUpload: true,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function updateFile (voucherId, params) {
    try{
        let requestData = {
            method: 'put',
            data: params,
            url: `${process.env.API_URL}/vouchers/${voucherId}/file`,
            isUpload: true,
        }
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

async function checkPwdPdf (formData) {
    try{
        let requestData = {
            method: 'post',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${process.env.API_URL}/checkPwdPdf/`,
            isUpload: true,
        }
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

// async function getPdf(id = "") {
//     let url = '/vouchers/' + id + '/file';
//     try {
//         let response = await ApiService.get(url);
//         return response;
//     } catch (error) {
//         return error;
//     }
// }

async function getPdf (id) {
    try {
        let requestData = {
            method: 'get',
            responseType: 'arraybuffer',
            url: `${process.env.API_URL}/vouchers/` + id + `/file`,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

export default VoucherService;




// WEBPACK FOOTER //
// ./src/services/module/voucher.service.js